import React, { useState, useEffect } from 'react';
import RMButton from 'components/customComponents/Controls/RMButton';
import RMTextInput from 'components/customComponents/Controls/RMTextInput';
import { isNullOrUndefined } from 'utils/Global';
import { ScreenInfoDTO } from 'business/models/Models';

function SearchAndList({ listData, setData, buttonDisabled = false, placeholder }: any) {
  const [searchValue, setSearchValue] = useState<string>(null);
  const [listItems, setListItems] = useState<ScreenInfoDTO[]>([]);
  const [activeList, setActiveList] = useState<ScreenInfoDTO[]>(listItems);
  const [selectedItem, setSelectedItem] = useState<ScreenInfoDTO[]>([]);
  function changeInputVal(e) {
    setSearchValue(e.target.value.toLowerCase());
  }

  function changeSelectedItem(item, ctrlKey, shiftKey) {
    if (ctrlKey) {
      const itemIndex = selectedItem.findIndex((selItem) => selItem.id === item.id);
      if (itemIndex === -1) {
        selectedItem.push(item);
      } else {
        selectedItem.splice(itemIndex, 1);
      }
      setSelectedItem([...selectedItem]);
    } else if (shiftKey && selectedItem.length > 0) {
      const [firstId, secondId] = [selectedItem[0]?.id, item?.id];
      if (!firstId || !secondId) {
        return;
      }

      const indices = [firstId, secondId].map((id) =>
        activeList.findIndex(({ id: listId }) => listId === id),
      );

      if (indices.includes(-1)) {
        return;
      }

      const [start, end] = indices.sort((a, b) => a - b);
      setSelectedItem(activeList.slice(start, end + 1));
    } else {
      selectedItem.splice(0, selectedItem.length);
      selectedItem.push(item);
      setSelectedItem([...selectedItem]);
    }
  }

  useEffect(() => {
    if (isNullOrUndefined(listData)) {
      return;
    }
    setListItems(listData);
    setActiveList(listData);
  }, [listData]);

  function addSelectedItem() {
    setData([...selectedItem]);
    setSelectedItem([...selectedItem]);
  }

  useEffect(() => {
    if (isNullOrUndefined(searchValue)) {
      return;
    }
    if (searchValue.length === 0) {
      setActiveList(listItems);
    } else {
      setActiveList(
        listItems.filter((item) => item.name.toLowerCase().includes(searchValue)),
      );
    }
  }, [searchValue]);

  function getPressedKey(event) {
    console.error('Ctrl Pressed');
  }
  return (
    <>
      <RMTextInput
        placeHolder={placeholder}
        onChange={changeInputVal}
        value={searchValue}
        style={{ height: '2.75rem', width: '100%', borderRadius: '3px' }}
      />
      <div id='searchandlist-container' className="wizard-list flex flex-column" onKeyPress={getPressedKey}>
        {activeList.map((item, index) => (
          <div
            id={`searchandlist-item-${item.id}`}
            key={`activeItem${index}`}
            className={`wizard-list-item ${
              selectedItem.some((lItem) => lItem.id === item.id)
                ? 'wizard-list-item-active'
                : ''
            }`}
            // Prevent browser's default text selection when shift+clicking
            onMouseDown={(e) => {
              if (e.shiftKey) {
                e.preventDefault();
              }
            }}
            onClick={(e) => changeSelectedItem(item, e.ctrlKey, e.shiftKey)}
          >
            <div id={`searchandlist-item-name-${item.id}`} className="truncate w-[344px]">{item.name}</div>
          </div>
        ))}
      </div>
      <div
        id='searchandlist-addbutton-container'
        style={{
          borderRadius: '4px',
          width: '12.5rem',
          height: '2.25rem',
          marginTop: '11px',
          maxHeight: '2.25rem',
          minHeight: '2.25rem',
          float: 'right',
        }}
      >
        <RMButton 
          id='searchandlist-addbutton'
          onClick={addSelectedItem}
          disabled={buttonDisabled || selectedItem.length === 0}
          label="Add to Selected"
          fullWidth={true}
        ></RMButton>
      </div>
    </>
  );
}

export default SearchAndList;
